(function () {
  function init(root) {
    var els = (root || document).querySelectorAll('.aaa-reveal, .aaa-claim');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // gentle parallax on hero orb
  var orb;
  function onMove(ev) {
    if (!orb) return;
    var r = orb.getBoundingClientRect();
    var x = (ev.clientX - (r.left + r.width / 2)) / r.width;
    var y = (ev.clientY - (r.top + r.height / 2)) / r.height;
    orb.style.transform = 'perspective(1200px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg)';
  }
  document.addEventListener('DOMContentLoaded', function () {
    orb = document.querySelector('[data-aaa-tilt]');
    if (orb && window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
      orb.style.transition = 'transform .6s cubic-bezier(.2,.7,.1,1)';
      window.addEventListener('mousemove', onMove, { passive: true });
    }
  });
})();

/* One-click Stack: adds whey + creatine + magnesium (each on its monthly plan) to the cart */
(function(){
  function addStack(mode, btn){
    var S = window.AAA_STACK; if(!S || !S.items || !S.items.length){ location.href='/collections/all'; return; }
    var items = S.items.map(function(it){ var o={ id: it.id, quantity: 1, properties: { '_bundle': 'The Stack' } }; if(mode!=='once' && it.plan){ o.selling_plan = it.plan; } return o; });
    if(btn){ btn.setAttribute('aria-busy','true'); btn.style.opacity='.6'; }
    fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items: items }) })
      .then(function(r){ if(!r.ok) throw r; location.href='/cart'; })
      .catch(function(){ if(btn){ btn.removeAttribute('aria-busy'); btn.style.opacity=''; } if(btn){ btn.textContent='Something went wrong. Tap to try again'; } });
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest('[data-aaa-stack], a[href$="#start-stack"], a[href$="#start-stack-once"]');
    if(!a) return;
    e.preventDefault();
    var mode = a.getAttribute('data-aaa-stack') || ((a.getAttribute('href')||'').indexOf('once')>-1 ? 'once' : 'sub');
    addStack(mode, a);
  });
})();

/* Gear: live products from the Fourthwall Storefront API */
(function(){
  function money(m){ try{ return new Intl.NumberFormat('en-US',{style:'currency',currency:m.currency||'USD'}).format(m.value).replace(/\.00$/,''); }catch(e){ return '$'+m.value; } }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function render(el){
    var token=el.dataset.token, store=el.dataset.store, col=el.dataset.collection||'all', limit=parseInt(el.dataset.limit||'8',10);
    var url='https://storefront-api.fourthwall.com/v1/collections/'+encodeURIComponent(col)+'/products?storefront_token='+encodeURIComponent(token)+'&currency=USD&size='+Math.max(limit*2,12);
    fetch(url).then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); }).then(function(d){
      var list=(d.results||[]).filter(function(p){ return !p.access || p.access.type==='PUBLIC'; }).slice(0,limit);
      if(!list.length) throw new Error('empty');
      el.innerHTML=list.map(function(p){
        var img=(p.images&&p.images[0])||{}; var src=img.transformedUrl||img.url||'';
        var price=p.price; if(!price && p.variants && p.variants.length){ price=p.variants.reduce(function(a,v){ return (!a||v.unitPrice.value<a.value)?v.unitPrice:a; },null); }
        var multi=p.variants && p.variants.length>1 && p.variants.some(function(v){ return v.unitPrice.value!==price.value; });
        var sold=p.state && p.state.type==='SOLD_OUT';
        return '<a class="aaa-gear__card aaa-reveal is-in" href="'+esc(store)+'/products/'+esc(p.slug)+'" target="_blank" rel="noopener">'+
          '<div class="aaa-gear__img">'+(src?'<img src="'+esc(src)+'" alt="'+esc(p.name)+'" loading="lazy">':'')+(sold?'<span class="aaa-gear__tag">Sold out</span>':'')+'</div>'+
          '<div class="aaa-gear__meta"><b>'+esc(p.name)+'</b><span>'+(price?(multi?'From ':'')+money(price):'')+'</span></div></a>';
      }).join('');
    }).catch(function(){
      var sec=el.closest('.aaa-gear'); el.remove(); if(sec){ sec.classList.add('aaa-gear--fallback'); }
    });
  }
  function init(){ document.querySelectorAll('[data-aaa-gear]').forEach(render); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
